export default "__VITE_ASSET__CZlOdZs$__"